import { gql } from '@apollo/client';

const LUMINA_PROFILE_DETAILS = gql`
    query MappedLuminaProfileDetails {
        mappedLuminaProfileDetails {
            practitioners {
                profile {
                    ... on Practitioner {
                        id
                        firstName
                        lastName
                        email
                        type
                        remainingPoints
                        isEnterpriseAccountMember
                        homepageUrl
                        subscriptionExpiryDate {
                            formatted
                        }
                        registrationDate {
                            formatted
                        }
                        country {
                            name
                        }
                        language {
                            code
                            id
                        }
                        practitionerSettings {
                            canUseQuestionnaire2
                            isShowSubscription
                        }
                        productQualifications {
                            qualificationName
                            colorTheme
                            products {
                            name
                            }
                        }
                        isApiEnabled
                    }
                }
            }
            staff {
                profile {
                    ... on Staff {
                    id
                    lastName
                    firstName
                    email
                    }
                }
            }
        }
    }
`;

export default LUMINA_PROFILE_DETAILS;